import OrderInput from "../OrderInput/OrderInput";
import { GridItem } from "../grids";
import { GridHeader } from "./TableHeader.styles";

interface ITableHeader {
    arrayHeaders: IHeaders[];
}

interface IHeaders {
    col: number;
    label: string;
    md_col?: number;
}

const TableHeader = ({ arrayHeaders }: ITableHeader) => {
    const handleOrder = (value: string, label: string) => {
    };

    return (
        <GridHeader>
            {arrayHeaders.map(({ col, md_col, label }) => (
                <GridItem sm-d-none md-d-none lg={col} key={label}>
                    <OrderInput label={label} onOrder={handleOrder} />
                </GridItem>
            ))}
        </GridHeader>
    );
};

export default TableHeader;
